import { ClientContext } from "ClientProvider";
import { getSingleRole } from "api/graphQL_role";
import { storeAuditLogs } from "api/users";
import { getProfileSecond } from "api/graphQL_users";
import Dropdown from "components/dropdown";
import React, { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { FiAlignJustify } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearAllCookie, setId, setUserId, getUserId } from "utils/auth";
import TripleToggleSwitch from "views/admin/payments/components/TripleToggleSwitch";

let mainText: string = "Lightning Checks";
if (["gateway-dev.lightningchecks.com","gateway.lightningchecks.com","testing.lightningchecks.com"].includes(window.location.hostname)) {
  mainText = "Lightning Checks";
} else if (["gateway-dev.bm2pay.com","gateway.bm2pay.com","gateway-stagging.bm2pay.com"].includes(window.location.hostname)) {
  mainText = "Bm2Pay";
} else if (window.location.hostname === "pay.paxum.com") {
  mainText = "Paxum";
} else {
  mainText = "Lightning Checks";
}

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const navigate = useNavigate();
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const [storeName, setStoreName] = useState<any>();
  const {
    setSingleRoleData, singleRoleData,
    setFilter, filter, activeTab, loadingTransaction,
  } = useContext(ClientContext);

  const hasSinglePayoutPermission = singleRoleData?.[0]?.payout?.value?.view_payout_list;
  const location = useLocation();

  const logout = async () => {
    const logData = {
      user_id: getUserId(),
      message: `${storeName?.first_name} ${storeName?.last_name} has been logged out`,
    };
    await storeAuditLogs(logData)
      .then(() => {
        clearAllCookie();
        localStorage.clear();
        sessionStorage.clear();
        navigate("/auth/sign-in");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message ?? "Please provide valid values");
      });
  };

  useEffect(() => {
    getProfileSecond()
      .then((res) => {
        setStoreName(res[0]);
        setId(res?.[0]?.role_id);
        setUserId(res?.[0]?.id);
        getSingleRole(res?.[0]?.role_id)
          .then((data) => setSingleRoleData(data ?? []))
          .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong"));
      })
      .catch(() => {});
  }, []);

  const labels = {
    left: { title: "All", value: "left" },
    right: { title: "Live", value: "right" },
    center: { title: "Test", value: "center" },
  };

  const onChange = (value: any) => {
    if (value === "left") setFilter({ ...filter, status: "all" });
    else if (value === "right") setFilter({ ...filter, status: "live" });
    else if (value === "center") setFilter({ ...filter, status: "test" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pageTitle =
    location?.pathname?.split("/")?.[2] === "smart-routing"
      ? "Smart Routing"
      : location?.pathname?.split("/")?.[2] === "client-details"
      ? "Client Details"
      : brandText.replace(/\bKyc\b/, "KYC");

  const showToggle =
    location.pathname.replace("/admin/", "") === "transactions" ||
    (location.pathname.replace("/admin/", "") === "payout" &&
      activeTab === "single" &&
      hasSinglePayoutPermission);

  const initials =
    (storeName?.first_name?.charAt(0)?.toUpperCase() || "") +
    (storeName?.last_name?.charAt(0)?.toUpperCase() || "");

  return (
    <nav className="nb-root">

      {/* ════════════════════════════════
          LEFT — brand pill + toggle
      ════════════════════════════════ */}
      <div className="nb-left">

        {/* Hamburger — mobile only */}
        <button className="nb-menu-btn" onClick={onOpenSidenav} aria-label="Open sidebar">
          <FiAlignJustify size={17} />
        </button>

        {/* Brand pill: "Payment Gateway  ›  {page}" */}
        <div className="nb-brand-pill">
          {/* Static portal label */}
          <div className="nb-portal-label">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            {mainText}
          </div>

          {/* Divider chevron */}
          <svg className="nb-chevron" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6"/>
          </svg>

          {/* Dynamic page name */}
          <span className="nb-page-label">{pageTitle || "Dashboard"}</span>
        </div>

        {/* Live / Test / All toggle — only on Transactions + single Payout */}
        {showToggle && (
          <></>
          // <div className="nb-toggle-wrap">
          //   <TripleToggleSwitch
          //     labels={labels}
          //     onChange={onChange}
          //     key={location.pathname}
          //     loadingTransaction={loadingTransaction}
          //   />
          // </div>
        )}
      </div>

      {/* ════════════════════════════════
          RIGHT — dark mode + avatar
      ════════════════════════════════ */}
      <div className="nb-right">
        {/* <button
          className="nb-icon-btn"
          aria-label="Toggle dark mode"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? <RiSunFill size={15} /> : <RiMoonFill size={15} />}
        </button> */}

        <Dropdown
          button={
            <button className="nb-avatar" aria-label="Profile menu">
              <span className="nb-avatar-initials">{initials || "?"}</span>
              <span className="nb-avatar-online" />
            </button>
          }
          children={
            <div className="nb-dropdown">
              <div className="nb-dropdown-header">
                <div className="nb-dropdown-avatar">{initials || "?"}</div>
                <div>
                  <p className="nb-dropdown-name">
                    {storeName?.first_name} {storeName?.last_name}
                  </p>
                  <p className="nb-dropdown-role">
                    {storeName?.role_name ?? "Logged in"}
                  </p>
                </div>
              </div>
              <div className="nb-dropdown-divider" />
              <div className="nb-dropdown-body">
                <Link to="/admin/profile" className="nb-dropdown-link">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Profile Settings
                </Link>
                <button onClick={logout} className="nb-dropdown-logout">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames="top-12 -right-2 w-max"
        />
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Navbar root ── */
        .nb-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: sticky; top: 0; z-index: 20;
          display: flex; align-items: center; justify-content: space-between;
          padding: 0 20px; height: 75px;
          background: rgba(255,255,255,0.92);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border-bottom: 1px solid #eef0f6;
          box-shadow: 0 1px 10px rgba(15,23,42,0.05);
          gap: 12px;
        }

        /* ── Left ── */
        .nb-left { display: flex; align-items: center; gap: 10px; min-width: 0; }

        .nb-menu-btn {
          display: flex; align-items: center; justify-content: center;
          width: 34px; height: 34px; border-radius: 9px;
          background: #f8fafc; border: 1.5px solid #e8edf3; color: #64748b;
          cursor: pointer; transition: all .15s; flex-shrink: 0;
        }
        .nb-menu-btn:hover { background: #f1f5f9; color: #0f172a; }
        @media (min-width: 1280px) { .nb-menu-btn { display: none; } }

        /* Brand pill */
        .nb-brand-pill {
          display: inline-flex; align-items: center; gap: 6px;
          height: 36px; padding: 0 13px;
          background: #f4f7ff;
          border: 1.5px solid #dde8fb;
          border-radius: 10px;
          white-space: nowrap; overflow: hidden;
          flex-shrink: 0;
        }

        .nb-portal-label {
          display: flex; align-items: center; gap: 6px;
          font-size: 11.5px; font-weight: 800;
          color: #2563eb; letter-spacing: -0.1px;
          flex-shrink: 0;
        }

        .nb-chevron { color: #b8c8e8; flex-shrink: 0; }

        .nb-page-label {
          font-size: 11.5px; font-weight: 700;
          color: #475569;
          max-width: 180px;
          overflow: hidden; text-overflow: ellipsis;
          letter-spacing: -0.1px;
        }

        .nb-toggle-wrap { display: flex; align-items: center; }

        /* ── Right ── */
        .nb-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

        .nb-icon-btn {
          display: flex; align-items: center; justify-content: center;
          width: 34px; height: 34px; border-radius: 9px;
          background: #f8fafc; border: 1.5px solid #e8edf3; color: #64748b;
          cursor: pointer; transition: all .15s;
        }
        .nb-icon-btn:hover { background: #f1f5f9; color: #0f172a; }

        .nb-avatar {
          position: relative; width: 34px; height: 34px; border-radius: 10px;
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          border: 2px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .18s;
          box-shadow: 0 2px 8px rgba(37,99,235,0.22);
        }
        .nb-avatar:hover { transform: translateY(-1px); box-shadow: 0 4px 14px rgba(37,99,235,0.32); }
        .nb-avatar-initials { font-size: 11.5px; font-weight: 800; color: #fff; letter-spacing: 0.3px; }
        .nb-avatar-online {
          position: absolute; bottom: -2px; right: -2px;
          width: 8px; height: 8px; border-radius: 50%;
          background: #16a34a; border: 2px solid #fff;
        }

        /* Dropdown */
        .nb-dropdown {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-width: 215px; background: #fff;
          border: 1px solid #e8edf3; border-radius: 14px;
          box-shadow: 0 8px 32px rgba(15,23,42,0.11); overflow: hidden;
        }
        .nb-dropdown-header {
          display: flex; align-items: center; gap: 11px;
          padding: 14px 15px;
          background: linear-gradient(135deg, #f8faff, #eff4ff);
          border-bottom: 1px solid #e8edf3;
        }
        .nb-dropdown-avatar {
          width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 800; color: #fff;
          box-shadow: 0 2px 8px rgba(37,99,235,0.22);
        }
        .nb-dropdown-name { font-size: 13px; font-weight: 700; color: #0f172a; margin-bottom: 2px; line-height: 1.2; }
        .nb-dropdown-role { font-size: 10.5px; font-weight: 600; color: #94a3b8; text-transform: capitalize; }
        .nb-dropdown-divider { height: 1px; background: #f1f5f9; }
        .nb-dropdown-body { padding: 8px; display: flex; flex-direction: column; gap: 2px; }
        .nb-dropdown-link {
          display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-radius: 8px;
          font-size: 13px; font-weight: 600; color: #374151; text-decoration: none; transition: all .15s;
        }
        .nb-dropdown-link:hover { background: #eff6ff; color: #2563eb; }
        .nb-dropdown-logout {
          display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-radius: 8px;
          width: 100%; font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px; font-weight: 600; color: #dc2626;
          background: none; border: none; cursor: pointer; text-align: left; transition: all .15s;
        }
        .nb-dropdown-logout:hover { background: #fff7f7; }

        /* Dark mode */
        .dark .nb-root {
          background: rgba(15,23,42,0.92);
          border-bottom-color: rgba(255,255,255,0.07);
        }
        .dark .nb-brand-pill {
          background: rgba(37,99,235,0.1);
          border-color: rgba(37,99,235,0.25);
        }
        .dark .nb-portal-label { color: #93c5fd; }
        .dark .nb-chevron { color: rgba(255,255,255,0.2); }
        .dark .nb-page-label { color: #94a3b8; }
        .dark .nb-menu-btn, .dark .nb-icon-btn {
          background: rgba(255,255,255,0.07); border-color: rgba(255,255,255,0.1); color: #94a3b8;
        }
        .dark .nb-menu-btn:hover, .dark .nb-icon-btn:hover {
          background: rgba(255,255,255,0.13); color: #f1f5f9;
        }
        .dark .nb-dropdown { background: #1e293b; border-color: rgba(255,255,255,0.09); }
        .dark .nb-dropdown-header { background: rgba(255,255,255,0.04); border-bottom-color: rgba(255,255,255,0.07); }
        .dark .nb-dropdown-name { color: #f1f5f9; }
        .dark .nb-dropdown-link { color: #cbd5e1; }
        .dark .nb-dropdown-link:hover { background: rgba(37,99,235,0.15); color: #93c5fd; }
        .dark .nb-dropdown-logout:hover { background: rgba(220,38,38,0.1); }
      `}</style>
    </nav>
  );
};

export default Navbar;